/** Shared currency-symbol lookup for buyer- and seller-facing price rendering. */

// Best-effort symbols for currencies an admin may add beyond the built-in set.
export const CURRENCY_SYMBOLS: Record<string, string> = {
  INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "د.إ", SGD: "S$",
  JPY: "¥", CNY: "¥", AUD: "A$", CAD: "C$", CHF: "CHF", THB: "฿",
  MYR: "RM", IDR: "Rp", SAR: "﷼", QAR: "﷼", ZAR: "R", NZD: "NZ$", HKD: "HK$",
};

/**
 * Symbol for an ISO currency code. Unknown codes render as the code itself;
 * a missing code falls back to INR, the platform default used by the backend
 * (see validator.py / post_ai_sync.py).
 */
export function currencySymbol(currency?: string | null): string {
  const code = (currency || "").toUpperCase();
  return CURRENCY_SYMBOLS[code] || code || "₹";
}
